// Copyright (c) Docugami, Inc. All rights reserved.

import { Breadcrumb, IBreadcrumbItem } from "@fluentui/react";
import { mapBreadcrumbsForDir } from "../file_helpers";

interface FileSystemBreadCrumbsProps {
    path: string;
    rootLabel: string;
    rootPath: string;
    onClick: (path: string) => void;
}

export const FileSystemBreadCrumbs = (props: FileSystemBreadCrumbsProps): JSX.Element => {
    if (props.path === props.rootPath) {
        return <></>;
    }
    
    function getCrumbItems(): IBreadcrumbItem[] {
        const pathCrumbs = mapBreadcrumbsForDir(props.path, props.rootLabel, props.rootPath);
        return pathCrumbs.map((c): IBreadcrumbItem => {
            return {
                text: c.text,
                key: c.key,
                onClick: () => props.onClick(c.key),
                isCurrentItem: c.key === props.path
            }
        });
    }

    return <Breadcrumb items={getCrumbItems()} />;
}
